<template>
  <div class="library-filters">
    <v-btn
      v-for="filter in filters"
      :key="filter.id"
      icon
      elevation="0"
      :class="checkFilterActive(filter) ? 'active' : ''"
      @click="filterBy(filter)"
    >
      <v-icon>{{ filter.icon }}</v-icon>
    </v-btn>
    <v-text-field
      :value="value"
      class="bh-input-pill rounded-pill"
      background-color="bh-gray--6"
      height="48px"
      append-icon="bhi-loupe"
      placeholder="Search for lib items"
      filled
      clearable
      hide-details
      @input="onInput('name', $event)"
      @click:clear="clearSearch"
      @click:append="runSearch"
      @keydown.enter="runSearch"
    ></v-text-field>
  </div>
</template>
<script>
import { debounce } from '@/helpers/debounce'
export default {
  name: 'LibraryFilters',
  props: {
    value: {
      type: String,
      default: '',
    },
    currentFilter: {
      type: [Boolean, Array, Object],
      default: false,
    },
  },
  data: () => ({
    tmpValue: '',
    selectedFilters: [],
    filters: [
      {
        id: 0,
        key: 'favorite',
        value: true,
        icon: 'bhi-heart',
        group: 'favorite',
      },
      // following filters are commented out as they are currently inefficient with 1000+ files
      // {
      //   id: 1,
      //   key: 'fileTypeIds',
      //   value: 18,
      //   icon: 'bhi-image',
      //   group: 'fileTypes'
      // },
      // {
      //   id: 2,
      //   key: 'fileTypeIds',
      //   value: 19,
      //   icon: 'bhi-play-circle',
      //   group: 'fileTypes'
      // },
      // {
      //   id: 3,
      //   key: 'fileTypeIds',
      //   value: [20, 21, 22, 23],
      //   icon: 'bhi-checklist',
      //   group: 'fileTypes'
      // },
      // {
      //   id: 4,
      //   key: 'fileTypeIds',
      //   value: [17],
      //   icon: 'bhi-file',
      //   group: 'fileTypes'
      // },
      // {
      //   id: 5,
      //   key: 'fileLabelId',
      //   value: [49],
      //   icon: 'bhi-meal',
      //   group: 'fileLabels'
      // },
      // {
      //   id: 6,
      //   key: 'fileLabelId',
      //   value: [51],
      //   icon: 'bhi-pulse',
      //   group: 'fileLabels'
      // },
      // {
      //   id: 7,
      //   key: 'fileLabelId',
      //   value: [50],
      //   icon: 'bhi-lightbulb',
      //   group: 'fileLabels'
      // },
    ],
  }),
  watch: {
    value: function(val) {
      if (val == '' || !val) {
        this.tmpValue = ''
      }
    },
    currentFilter: {
      handler(newVal, oldVal) {
        if (this.currentFilter) this.selectedFilters = [...this.currentFilter]
        else this.selectedFilters = []
      },
      deep: true,
    },
  },
  methods: {
    clearSearch() {
      this.tmpValue = ''
    },
    runSearch() {
      if (this.tmpValue)
        debounce(
          () => {
            this.$emit('search-on:run', { name: this.tmpValue })
          },
          100,
          'LibraryFilters',
        )
    },
    onInput(key, value) {
      this.tmpValue = value
      if (this.tmpValue)
        debounce(
          () => {
            this.$emit('search-on:input', { key, value })
          },
          1000,
          'LibraryFilters',
        )
      else
        debounce(
          () => {
            this.$emit('filter', false)
          },
          1000,
          'LibraryFilters',
        )
    },
    checkFilterActive(filter) {
      return this.selectedFilters &&
        this.selectedFilters.findIndex(
          item => item.key == filter.key && item.value == filter.value,
        ) > -1
        ? 1
        : 0
    },
    currentFilterCheck(filter) {
      if (this.selectedFilters) {
        if (Array.isArray(this.selectedFilters)) {
          let groupItemIndex = this.selectedFilters.findIndex(
            item => item.group == filter.group,
          )
          if (groupItemIndex > -1) {
            let addNew = false
            if (this.selectedFilters[groupItemIndex].value != filter.value)
              addNew = true
            this.selectedFilters.splice(groupItemIndex, 1)
            if (addNew) this.selectedFilters.push(filter)
          } else this.selectedFilters.push(filter)
        } else {
          if (
            filter.key == this.currentFilter.key &&
            filter.value == this.currentFilter.value
          )
            this.selectedFilters = false
          else this.selectedFilters = [filter]
        }
      }
    },
    filterBy(filter) {
      this.clearSearch()
      this.currentFilterCheck(filter)
      this.$emit('filter', this.selectedFilters)
    },
  },
}
</script>
<style lang="scss">
.library-filters {
  display: flex;
  align-items: center;
  margin-left: auto;
  .v-btn {
    background: $bh-gray--6;
    margin-right: 10px;
    .v-icon {
      color: $bh-gray--2;
    }
    &:hover {
      .v-icon {
        color: $bh-blue;
      }
    }
    &.active {
      background: $bh-blue;
      .v-icon {
        color: $bh-white;
      }
    }
  }
  .bh-input-pill {
    margin: 0 8px !important;
    width: 264px;
    height: 48px !important;
    .v-input__slot {
      align-items: center;
      height: 48px;
      min-height: 0 !important;
      background: $bh-gray--6 !important;
      &:hover {
        background: $bh-gray--5 !important;
      }
      &::before,
      &::after {
        content: '';
        display: none;
      }

      .v-input__append-inner {
        align-self: center;
        margin-top: 0 !important;
      }

      .v-icon {
        color: $bh-blue;
      }
    }
  }
}
</style>
